'use strict';

require('./kendo.core.js');

kendo.jQuery;

function valueMapperOptions(options, value, callback) {
    return {
        value: (options.selectable === "multiple" || options.checkboxes) ? value : value[0],
        success: function(response) {
            callback(response);
        }
    };
}

exports.valueMapperOptions = valueMapperOptions;
